export default [
    {
        path: "/se",
        name: "se",
        meta: {title: "HCP List"},
        component: () => import("../views/se/se-list.vue")
        // component: () => import("../views/se/common-hcp-list.vue")
    },
     {
        path: "/commonse",
        name: "commonse",
        meta: {title: "Common HCP List"},
        component: () => import("../views/se/common-hcp-list.vue")
    },
    {
        path: "/vce",
        name: "vce",
        meta: {title: "vCE-List"},
        component: () => import("../views/se/vce-list.vue")
    },
    {
        path: "/se/srMenu/:seId/:mlId",
        name: "sr-menu",
        meta: {title: "My-SR-Menu"},
        component: () => import("../views/se/view/sr-menu.vue")
    },
    {
        path: "/se/:seId/:mlId",
        name: "se-view",
        meta: {title: "My-HCP-View"},
        component: () => import("../views/se/view/se-view.vue")
    },
    {
        path: "/vce/:seId/:mlId",
        name: "vce-view",
        meta: {title: "My-VCE-View"},
        component: () => import("../views/se/view/vce-view.vue")
    },
]
